import React from 'react'
import SummaryView from '../detail/SummaryView'

const SwimmingView = (props) => {
  const { data: { summary = {} } } = props
  const fieldsOfInterest = ['start_date', 'distance', 'duration', 'avg_speed', 'calories']

  return <SummaryView fieldsOfInterest={fieldsOfInterest} summary={summary} />
}

export default SwimmingView
